import { hydrateWhenVisible, hydrateOnInteraction, hydrateNever } from 'vue-lazy-hydration'

import Moment from 'moment-timezone'
import LandingPagesMixin from 'mixins/landing-pages'
import PageLinks from 'mixins/page-links.js'
import { PROMOTIONS_DATES } from 'config/landing-pages'
import { PROMOTION_DATES } from 'config/promotion-dates'
import InsiderMixin from '@/mixins/insider-mixin'
import insiderEnum from '@/services/Insider/InsiderEnum'

import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

const RcHero = () => import('components/HomeV2/Hero/index.vue')
const AppSearchInstance = () => import('components/Search/FormInstance/index.vue')
const RcFaq = hydrateWhenVisible(() => import('components/HomeV2/Faq/Faq.vue'))
const PromotionsV2 = hydrateWhenVisible(() => import('components/best-deals/promotionsV2/promotionsV2.vue'))
const RcNewsletter = hydrateWhenVisible(() => import('components/HomeV2/Newsletter/Newsletter.vue'))
const RcDownloadApp = hydrateWhenVisible(() => import('components/HomeV2/DownloadApp/DownloadApp.vue'))
const RcBenefits = hydrateWhenVisible(() => import('components/HomeV2/Benefits/index.vue'))
const RcTrustpilot = hydrateNever(() => import('components/HomeV2/Trustpilot/index.vue'))
const TopDestinationsCards = hydrateWhenVisible(() => import('components/landing-pages/top-destinations-cards/top-destinations-cards.vue'))
const ImageBannerModal = hydrateOnInteraction(() => import('components/ImageBannerModal/ImageBannerModal.vue'))
const Modal = hydrateOnInteraction(() => import('components/Modal/Default/Default.vue'))
const AppFiltersPromotions = hydrateOnInteraction(() => import('components/Booking/Filters/Promotion/FiltersPromotions.vue'))

export default {
  layout: 'customEvent',

  mixins: [LandingPagesMixin, PageLinks, InsiderMixin],

  components: {
    RcHero,
    RcFaq,
    AppSearchInstance,
    RcNewsletter,
    RcDownloadApp,
    RcBenefits,
    RcTrustpilot,
    TopDestinationsCards,
    ImageBannerModal,
    Modal,
    AppFiltersPromotions,
    PromotionsV2
  },

  fetch ({ store }) {
    store.dispatch('header/SET_CONFIG', {
      logo: true,
      menu: true,
      showFlag: true
    })

    store.dispatch('footer/SET_CONFIG', {
      show: true
    })
  },

  name: 'view-best-deals',

  data () {
    return {
      route: 'routes.best-deals',
      bestDeals: null,
      locale: this.$i18n.locale,
      consumerBanner: PROMOTIONS_DATES.consumerBanner,
      dates: PROMOTIONS_DATES.blackfriday,
      currentYear: new Date().getFullYear(),
      dealsListFiltered: [],
      devicePixelRatio: 0,
      isVisible: false,
      canShowCoupon: false,
      canShowConsumerBanner: false,
      canShowPromotions: false,
      canShowTopDestinations: false,
      canShowBenefits: false,
      canShowFaq: false,
      canShowDownload: false,
      canShowNewsletter: false
    }
  },

  async mounted () {
    this.devicePixelRatio = window.devicePixelRatio
    await this._setInsiderObject(
      insiderEnum.PROMOTTIONS,
      {
        custom: {
          requestor_id: this.$store.getters.getMobicarRequestorID,
          request_device: insiderEnum.MOBILE
        }
      }
    )
    this.classBestDeal()
  },

  computed: {
    isCheckedUrlToken () {
      return (process.env.TOKEN_LP === this.$route.query.token)
    },

    isBf () {
      return this.$store.getters.getCustomEvent === 'black_friday_evento'
    },

    currentDate () {
      return (this.$route.query.data && this.isCheckedUrlToken) ? this.$route.query.data : new Moment().format('YYYY-MM-DD')
    },

    titleBanner () {
      if (this.isBf) {
        return this.$t('lp.promo.carrental.title')
      } else if (this.canShowRentDayBanner) {
        return this.$t('rentday.es.latam.text1')
      } else if (this.canShowRentDayBannerToNamAndEmea) {
        return this.$t('rentday.nam.emea.text1')
      } else {
        return this.$t('seo.promo.h1')
      }
    },

    canShowRentDayBanner () {
      return (['pt-br', 'es-mx'].includes(this.locale) &&
        Moment(this.currentDate).isBetween(PROMOTION_DATES.rentdayCampaign.starts, PROMOTION_DATES.rentdayCampaign.ends, null, '[]'))
    },

    canShowRentDayBannerToNamAndEmea () {
      const locales = ['en', 'en-gb', 'fr-ca', 'es', 'it-it', 'fr-fr', 'de-de', 'nl-nl']
      const isValidLocale = locales.includes(this.locale)
      return (isValidLocale &&
        Moment(this.currentDate).isBetween(PROMOTION_DATES.rentdayCampaignToNamAndEmea.starts, PROMOTION_DATES.rentdayCampaignToNamAndEmea.ends, null, '[]'))
    },

    canShowRentDayDate () {
      const rentDay = '2023-04-28'

      if (this.currentDate === rentDay) {
        return this.$t('rentday.es.latam.text3')
      } else {
        return this.$t('rentday.es.latam.text2')
      }
    },

    benefitsItems () {
      return {
        title: this.$t('newhome.benefits.title'),
        subtitle1: this.$t('newhome.menu.bestprice'),
        subtitle2: this.$t('newhome.benefits.v2title'),
        subtitle3: this.$t('home.advantages.title.3'),
        subtitle4: this.$t('newhome.benefits.v4title')
      }
    },

    currentDateBF () {
      return (this.$route.query.data && this.isCheckedUrlToken) ? this.$route.query.data : new Moment().format('YYYY-MM-DD HH:mm')
    },

    getSubtitleDiscount () {
      let percentage = 30
      const data = this.currentDateBF

      const bfCampaign = PROMOTION_DATES.blackFridayCampaign
      if (Moment(data).isBetween(bfCampaign.starts_pre, bfCampaign.finish_pre, null, '[]')) {
        percentage = 60
      } else if (Moment(data).isBetween(bfCampaign.starts_week, bfCampaign.finish_week, null, '[]')) {
        percentage = 70
      } else if (Moment(data).isBetween(bfCampaign.starts_extended, bfCampaign.finish_extended, null, '[]')) {
        percentage = 60
      }

      return this.$t('lp.promo.discount.title', { PERCENTAGE_VALUE: percentage })
    },

    getSubtitle () {
      if (this.locale === 'es-mx') {
        return this.$t('promotions.banner.subtitle')
      }

      return this.getSubtitleDiscount
    }
  },

  head () {
    return {
      title: this.getTitlePromotion(),
      link: this.getPageLinks(),
      meta: [
        {
          hid: 'title',
          name: 'title',
          content: this.getTitlePromotion()
        },
        {
          hid: 'description',
          name: 'description',
          content: this.getDescriptionPromotion()
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.getTitlePromotion()
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.getDescriptionPromotion()
        }
      ],
      bodyAttrs: {
        class: 'view-best-deals'
      }
    }
  },

  methods: {
    classBestDeal () {
      this.$store.getters.getUserGeoipCountry ? this.$store.getters.getUserGeoipCountry : this.$store.getters.getAppResidenceCountry
    },
    visibilityChanged (isVisible, entry) {
      this.isVisible = isVisible
    },
    canshowPromotions () {
      return ['pt-br', 'en', 'es-mx', 'es', 'es-cl'].includes(this.locale)
    },

    canshowPromotionLinks () {
      if (['pt-br', 'en', 'es-mx', 'es', 'es-cl'].includes(this.locale)) {
        return true
      }
    },

    canshowConsumerBanner () {
      return (this.locale === 'pt-br' &&
        Moment(this.currentDate).isBetween(this.consumerBanner.starts, this.consumerBanner.ends, null, '[]') &&
        this.$store.getters.getMobicarRequestorID === process.env.MOBICARREQUESTOR_ID)
    },

    openRules () {
      $('#md-consumer-banner').modal('open')
    },

    rulesContent () {
      const content = []
      content.push('<ol>')
      content.push(`
        <li><span>Válido para reservas confirmadas de 22/03/2019 a 31/03/2019 e com retirada até 30/06/2019.</span></li>
        <li><span>Desconto válido somente para pagamento online pelo site ou aplicativo da Rentcars.</span></li>
        <li><span>Valor mínimo da reserva: R$ 600.</span></li>
        <li><span>Somente para a primeira locação.</span></li>
        <li><span>O cupom não é aplicável a reservas solicitadas ou realizadas pela central de atendimento e/ou parceiros. A central de atendimento pode te ajudar a fazer a reserva. Neste caso, os atendentes vão orientar o passo a passo até a conclusão da locação e aplicação do cupom.</span></li>
        <li><span>O cupom é válido para reservas de 1 até 59 diárias.</span></li>
        <li><span>O locatário deverá preencher todos os requisitos de locação. Para alguns países e determinados grupos de veículos poderá haver regras específicas, consulte nossa Central de Reservas para mais informações.</span></li>
        <li><span>Desconto total será aplicado sobre o valor pré-pago no site da Rentcars e não se aplicará a valores pagos no destino.</span></li>
        <li><span>O desconto não se aplicará a serviços contratados ou pagos diretamente no balcão da locadora.</span></li>
        <li><span>O cupom não poderá ser aplicado após a emissão da reserva.</span></li>
        <li><span>Qualquer alteração na reserva após a confirmação do pagamento é passível de atualização de valores e disponibilidade de veículos.</span></li>
        <li><span>Caso haja alteração que gere redução do valor pré-pago, o desconto será proporcionalmente recalculado./span></li>
        <li><span>Em caso de cancelamento antecipado da reserva, o cupom será cancelado e perderá a validade, não sendo possível a reutilização. As políticas de retenção serão aplicadas sem considerar o valor do cupom. Em caso de cancelamento antes do horário de retirada da reserva, a retenção será de 5% do valor total da mesma. Já no caso de cancelamento após o horário de retirada, a retenção será de 1 diária sobre o valor total da reserva.</span></li>
        <li><span>Não é permitido a venda, a transferência e nem a troca em dinheiro desse cupom.</span></li>
        <li><span>Caso seja detectado que o cupom tenha sido utilizado de forma especulativa, falsa ou fraudulenta, nos reservamos o direito de alterar ou cancelar tanto a promoção quanto às reservas a qualquer momento sem prévio aviso. </span></li>
        <li><span>O cupom não é cumulativo.</span></li>
      `)
      content.push('</ol>')
      return content.join('')
    },

    getTitlePromotion () {
      return Moment(this.currentDate).isBetween(PROMOTION_DATES.titleCyberMonday.starts, PROMOTION_DATES.titleCyberMonday.ends, null, '[]') && this.locale === 'pt-br'
        ? this.$t('seo.promo.titleCyberMonday')
        : Moment(this.currentDate).isBetween(PROMOTION_DATES.titleBlackFriday.starts, PROMOTION_DATES.titleBlackFriday.ends, null, '[]') && this.locale === 'pt-br'
          ? this.$t('seo.promo.titleBlackFriday')
          : this.$t('seo.promo.title')
    },

    getDescriptionPromotion () {
      return Moment(this.currentDate).isBetween(PROMOTION_DATES.titleCyberMonday.starts, PROMOTION_DATES.titleCyberMonday.ends, null, '[]') && this.locale === 'pt-br'
        ? this.$t('seo.promo.descriptionCyberMonday')
        : Moment(this.currentDate).isBetween(PROMOTION_DATES.titleBlackFriday.starts, PROMOTION_DATES.titleBlackFriday.ends, null, '[]') && this.locale === 'pt-br'
          ? this.$t('seo.promo.descriptionBlackFriday')
          : this.$t('seo.promo.description')
    },

    canShowBannerPortugal15off () {
      return Moment(this.currentDate).isBetween(PROMOTIONS_DATES.portugal15off.starts, PROMOTIONS_DATES.portugal15off.ends, null, '[]') &&
            ((this.$store.getters.getLocale === 'pt-pt' && this.$store.getters.getAppResidenceCountry === 'PT'))
    },

    canShowOutboundUSA () {
      return (['ES', 'IT'].includes(this.$store.getters.getAppResidenceCountry) &&
        ['es', 'it-it'].includes(this.$store.getters.getLocale) &&
        Moment(this.currentDate).isBetween(PROMOTION_DATES.outboundCampaign.starts, PROMOTION_DATES.outboundCampaign.ends, null, '[]'))
    },

    canShowCouponsEs () {
      return (
        (
          (((['AR', 'BO', 'CL', 'CO', 'CR', 'EC', 'SV', 'HN', 'GT', 'NI', 'PA', 'PY', 'PR', 'PE', 'DO', 'UY'].includes(this.$store.getters.getAppResidenceCountry) &&
          ['es'].includes(this.$store.getters.getLocale))) ||
          ['es-cl'].includes(this.$store.getters.getLocale))
        ) &&
          Moment(this.currentDate).isBetween(PROMOTION_DATES.couponSlider.starts, PROMOTION_DATES.couponSlider.ends, null, '[]')
      )
    },

    canShowCouponApp () {
      return (
        (
          (((['AR', 'BO', 'CL', 'CO', 'CR', 'EC', 'SV', 'HN', 'GT', 'NI', 'PA', 'PY', 'PR', 'PE', 'DO', 'UY'].includes(this.$store.getters.getAppResidenceCountry) &&
          ['es'].includes(this.$store.getters.getLocale))) ||
          ['es-cl'].includes(this.$store.getters.getLocale))
        ) &&
          Moment(this.currentDate).isBetween(PROMOTION_DATES.couponSliderApp.starts, PROMOTION_DATES.couponSliderApp.ends, null, '[]')
      )
    },

    getImgBg () {
      if (this.isBf) {
        return '/images/promotions/blackfriday-2022/header/banner-black-friday-mobile-event'
      } else if (this.canShowRentDayBanner || this.canShowRentDayBannerToNamAndEmea) {
        return '/images/promotions/banner-rentday-promo'
      } else if (this.devicePixelRatio >= 2) {
        return '/images/promotions/background-v3@2x'
      } else {
        return '/images/promotions/background-v3'
      }
    },

    canShowCouponVisibility (canShowCoupon) {
      this.canShowCoupon = canShowCoupon
    },

    canShowConsumerBannerVisibility (canShowConsumerBanner) {
      this.canShowConsumerBanner = canShowConsumerBanner
    },

    canShowPromotionsVisibility (canShowPromotions) {
      this.canShowPromotions = canShowPromotions
    },

    canShowTopDestinationsVisibility (canShowTopDestinations) {
      this.canShowTopDestinations = canShowTopDestinations
    },

    canShowBenefitsVisibility (canShowBenefits) {
      this.canShowBenefits = canShowBenefits
    },

    canShowFaqVisibility (canShowFaq) {
      this.canShowFaq = canShowFaq
    },

    canShowDownloadVisibility (canShowDownload) {
      this.canShowDownload = canShowDownload
    },

    canShowNewsletterVisibility (canShowNewsletter) {
      this.canShowNewsletter = canShowNewsletter
    }

  }

}
